import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AutogeneratorList from "./AutogeneratorList";
import {getFiltersByAccount} from "../../helpers/Helpers";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import {Card} from "@material-ui/core";

class Autogenerator extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            autogeneratorList: [],
            contadores: [],
            years: [],
            contador: '',
            year: '',
        };
    }

    async componentDidMount() {
        this.init();
    }

    init = async () => {
        const filters = getFiltersByAccount();
        const contadores = this.getContadores(filters);
        const years = this.getYears(filters);
        let firstContador = '';
        let firstYear = '';

        if (contadores.length > 0 && years.length > 0) {
            firstContador = contadores[0];
            firstYear = years[0];
        }

        this.setState({
            contadores: contadores,
            years: years,
            contador: firstContador.value,
            year: firstYear.value,
        });

        await this.getAutogenerators(firstContador.value, firstYear.value);

    }

    getContadores = (data) => {
        let contadores = [];
        for (let i = 0; i < data.contadores.length; i++) {
            const obj = data.contadores[i];
            contadores.push({
                value: obj.cuentaDetalleContador,
                text: obj.cuentaDetalleContador,
            });
        }
        return contadores;
    }

    getYears = (data) => {
        let years = [];
        for (let i = 0; i < data.contadores.length; i++) {
            const obj = data.contadores[i];
            for (let j = 0; j < obj.periodos.length; j++) {
                const obj2 = obj.periodos[j];
                years.push({
                    value: obj2.periodo,
                    text: obj2.periodo,
                });
            }
        }
        return years;
    }

    getAutogenerators = async (contador, year) => {
        const data = await Api.get(`${Env.UrlSeguridad}/getContadorDetalleMes/${contador}/${year}`);
        if (data.cod === '1') {
            this.setState({
                autogeneratorList: data.meses,
            });
        }
    }

    handleOnChangeContador = async (e) => {
        this.setState({
            contador: e.target.value
        });
        await this.getAutogenerators(e.target.value, this.state.year);
    }

    handleOnChangeYear = async (e) => {
        this.setState({
            year: e.target.value
        });
        await this.getAutogenerators(this.state.contador, e.target.value);
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Autogeneradores'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Autogeneradores</span>
                </h2>


                <div style={{width: '700px', margin: 'auto'}}>

                    <Card>
                        <Grid container>
                            <Grid item xs={6} style={{padding: '20px'}}>
                                <FormControl variant="outlined" style={{width: '300px'}}>
                                    <InputLabel id="lblContador">Contador</InputLabel>
                                    <Select
                                        labelId="lblContador"
                                        id='contador'
                                        name='contador'
                                        value={this.state.contador}
                                        onChange={this.handleOnChangeContador}
                                        label="Contador"
                                        variant='outlined'
                                    >

                                        {this.state.contadores.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.value}>{val.text}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} style={{padding: '20px'}}>
                                <FormControl variant="outlined" style={{width: '300px'}}>
                                    <InputLabel id="lblYear">Año</InputLabel>
                                    <Select
                                        labelId="lblYear"
                                        id='year'
                                        name='year'
                                        value={this.state.year}
                                        onChange={this.handleOnChangeYear}
                                        label="Año"
                                        variant='outlined'
                                    >

                                        {this.state.years.map((val, index) => {
                                            return (
                                                <MenuItem key={index}
                                                          value={val.value}>{val.text}</MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div style={{padding: '20px'}}>
                            <AutogeneratorList data={this.state.autogeneratorList}/>
                        </div>

                    </Card>
                </div>


            </div>
        );
    }
}

export default withRouter(Autogenerator)